import VModal from 'vue-js-modal';
import Vue from 'vue';

Vue.use(VModal, {componentName: 'vmodal'});

require('../../sass/components/_modal2.scss');
export const Modal = {
    name: 'Modal',
    props: {
        name: {
            type: String,
            required: true
        },
        withCloseButton: {
            type: Boolean,
            default: true
        },
        noEdge: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        classes() {
            return ['modal2', !this.noEdge && 'modal--with-edge'];
        }
    },
    methods: {
        close(e) {
            this.$modal.hide(this.name);
        }
    },
    template: `
        <vmodal :adaptive="true" 
                :name="name" 
                v-bind="$attrs" 
                v-on="$listeners" 
                :class="classes">
            <div v-if="withCloseButton" 
                 @click="close"
                 class="modal2__close-button">
            </div>            
            <slot></slot>
        </vmodal>
    `
};